var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.793031 8.70679C0.980558 8.89426 1.23487 8.99957 1.50003 8.99957C1.76519 8.99957 2.0195 8.89426 2.20703 8.70679L8.50003 2.41379L14.793 8.70679C14.9816 8.88894 15.2342 8.98974 15.4964 8.98746C15.7586 8.98518 16.0094 8.88001 16.1948 8.69461C16.3803 8.5092 16.4854 8.25838 16.4877 7.99619C16.49 7.73399 16.3892 7.48139 16.207 7.29279L9.20703 0.292787C9.0195 0.105316 8.76519 9.85586e-08 8.50003 9.53965e-08C8.23487 9.22344e-08 7.98056 0.105316 7.79303 0.292787L0.793031 7.29279C0.60556 7.48031 0.500244 7.73462 0.500244 7.99979C0.500244 8.26495 0.60556 8.51926 0.793031 8.70679Z","fill":"#3D2B30"}));
}

ArrowUp.defaultProps = {"width":"17","height":"9","viewBox":"0 0 17 9","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
